<template>
  <div class="login"
    :style="{ background: `url(${infoForm.login_background_image == '' ? backImg : infoForm.login_background_image}) center/cover` }">
    <!-- <div class="login"> -->
    <div v-if="is_loginForm" class="appdiv">
      <h1 v-if="infoForm.app_name != ''">{{ infoForm.app_name }}</h1>
      <h1 v-else>数字化中台</h1>
      <h5>{{ h5_text }}</h5>
      <div v-if="is_pass" class="userna" :style="sty">
        <a-tabs v-if="is_modify" default-active-key="1" centered @change="handlerChange">
          <a-tab-pane key="1" tab="帐号密码登录">
            <UserForm :terms="terms" :is_user="is_user" :username="username" @handlerClause="handlerClause"
              @handlerForgetPass="handlerForgetPass" />
          </a-tab-pane>
          <a-tab-pane key="2" tab="手机号登录">
            <PhoneForm :terms="terms" :is_user="is_user" @handlerClause="handlerClause" />
          </a-tab-pane>
        </a-tabs>
        <div v-else style="padding-top: 24px">
          <template v-if="is_modifyPass">
            <a-form ref="modifyForm" :model="modifyForm" :rules="rules" class="phone" style="margin-top: 32px">
              <a-form-item name="mob">
                <a-input v-model:value="modifyForm.mob" size="large" :maxLength="11" :minLength="11"
                  onkeyup="this.value=this.value.replace(/\D/g,'')" placeholder="手机号">
                  <template #prefix>
                    <MobileOutlined style="color: rgba(0, 0, 0, 0.25)" />
                  </template>
                </a-input>
              </a-form-item>
            </a-form>
            <a-form ref="modifyForm_2" :model="modifyForm_2" :rules="rules" class="phone">
              <a-form-item name="verkey">
                <a-input v-model:value="modifyForm_2.verkey" size="large" style="width: 70%; float: left"
                  placeholder="验证码">
                  <template #prefix>
                    <UserOutlined type="user" style="color: rgba(0, 0, 0, 0.25)" />
                  </template>
                </a-input>
                <a-button v-if="codeShow" type="primary" @click="handlerPassForm('modifyForm', modifyForm)"
                  class="code">
                  {{ passText }}
                </a-button>
                <a-button v-else disabled class="code">
                  {{ newtimes }}秒后重试
                </a-button>
              </a-form-item>
            </a-form>
          </template>
          <template v-else>
            <a-form ref="newPassForm" :model="newPassForm" :rules="rules" style="margin-top: 32px">
              <a-form-item name="fpwd">
                <a-input-password size="large" type="password" placeholder="请输入新的密码" v-model="newPassForm.fpwd">
                  <template #prefix>
                    <LockOutlined class="site-form-item-icon" style="color: rgba(0, 0, 0, 0.25)" />
                  </template>
                </a-input-password>
              </a-form-item>
              <a-form-item name="spwd">
                <a-input-password size="large" type="password" placeholder="请再次输入密码" v-model="newPassForm.spwd">
                  <template #prefix>
                    <LockOutlined class="site-form-item-icon" style="color: rgba(0, 0, 0, 0.25)" />
                  </template>
                </a-input-password>
              </a-form-item>
            </a-form>
          </template>
        </div>
      </div>
      <div v-else-if="!is_pass" class="forget_pass">
        <template v-if="!is_newpass">
          <ForgetPass ref="passForm" @handlerForget="handlerForget" />
        </template>
        <template v-else>
          <ReserPass :mob="passmob" @handlerReset="handlerReset" />
        </template>
      </div>
      <div class="weixin" :style="styl">
        <div class="qr-code">
          <div v-show="qrcode" id="wx_reg"></div>
          <img v-show="!qrcode" style="width: 100%; height: 100%" :src="offline" />
        </div>
        <div class="log" @click="handlerBack">
          <a>
            <LeftCircleOutlined />&nbsp;&nbsp;&nbsp;账号密码登录
          </a>
        </div>
      </div>
      <div v-if="!is_modify" class="is_modify">
        <a-button v-if="!newModel" type="primary" @click="handlerForget('modifyForm_2', modifyForm_2)"
          style="width: 100%; height: 40px; margin-bottom: 18px">下一步</a-button>
        <a-button v-if="!newModel" @click="() => {
          is_modify = true;
          h5_text = '效率就是生产力';
        }
          " style="width: 100%; height: 40px">取消</a-button>
        <a-button v-else-if="newModel" type="primary" @click="handlerReset('newPassForm', newPassForm)"
          style="width: 100%; height: 40px">确认修改</a-button>
      </div>
      <div class="login-on" v-if="is_modify" :style="sty">
        <div v-if="is_pass" class="login-on-2">
          <a-checkbox v-model:checked="terms" @change="changeClause">
            我同意
          </a-checkbox>
          <a @click="handlerClause" style="z-index: 9">服务条款</a>
        </div>
        <div v-if="is_pass" class="login-on-1">
          <span style="padding-right: 16px">其他登录方式 </span>
          <img src="../../assets/otherlogin.jpg" @click="handlerwechat" />
        </div>
        <div v-else class="login-on-3">
          <span style="padding-right: 16px">其他登录方式 </span>
          <img src="../../assets/otherlogin.jpg" @click="handlerwechat" />
        </div>
        <a v-if="!is_pass" @click="() => { is_pass = true; h5_text = '效率就是生产力'; }" style="float: right">返回登录页</a>
      </div>
    </div>
    <div v-else class="appdiv">
      <h1>中南幕墙数字化中台</h1>
      <h5>效率就是生产力</h5>
      <div v-if="ticket" class="forget_pass">
        <a-alert message="请绑定您在系统中已注册的手机号" type="info" show-icon />
        <a-form ref="bindForm" :model="bindForm" :rules="rules" class="phone" style="margin-top: 32px">
          <a-form-item name="mob">
            <a-input v-model:value="bindForm.mob" size="large" :maxLength="11"
              onkeyup="this.value=this.value.replace(/\D/g,'')" placeholder="请输入手机号">
              <template #prefix>
                <MobileOutlined style="color: rgba(0, 0, 0, 0.25)" />
              </template>
            </a-input>
          </a-form-item>
        </a-form>
        <a-form ref="bindForm_2" :model="bindForm_2" :rules="rules" class="phone">
          <a-form-item name="verkey">
            <a-input v-model:value="bindForm_2.verkey" size="large" style="width: 70%; float: left" placeholder="验证码">
              <template #prefix>
                <UserOutlined type="user" style="color: rgba(0, 0, 0, 0.25)" />
              </template>
            </a-input>
            <a-button v-if="bindShow" type="primary" @click="handlerBindForm('bindForm', bindForm)" class="code">
              {{ bindText }}
            </a-button>
            <a-button v-else disabled class="code">
              {{ bindtimes }}秒后重试
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-else class="forget_pass">
        <a-alert style="font-size: 12px" message="请使用微信扫描二维码，授权接收平台公众号消息通知" type="info" show-icon />
        <img style="display: block; width: 190px; margin: 12px auto"
          src="../../assets/a112cfd14b6575dc9210b600c57c915.png" alt="" />
        <p style="width: 176px; margin: 0 auto 18px">
          <a @click="() => {
            is_loginForm = true;
          }
            ">返回登录页</a>
          <a @click="handlerTicket('1')" style="float: right">跳过此步骤</a>
        </p>
        <a-button type="primary" @click="handlerTicket('2')" style="display: block; width: 176px; margin: 0 auto">已完成扫码
          / 直接登录</a-button>
      </div>
      <div v-if="ticket" class="login-in" :style="sty">
        <a-button style="width: 100%; height: 100%" type="primary" @click="handlerBinding('bindForm_2', bindForm_2)">
          确认提交</a-button>
      </div>
    </div>
    <a-modal v-model:visible="clauseModal" title="服务条款" :bodyStyle="bodyStyles" ok-text="已阅读并同意" cancel-text="不同意"
      :maskClosable="false" @ok="clauseOk" @cancel="() => { terms = false; clauseModal = false; }" centered
      :width="1000">
      <Termsindex />
    </a-modal>
  </div>
</template>
<script>
import { listenKeyDownFunc } from "@/utils";
import backImg from "../../assets/login.jpg"
import { $post, $get } from "@/utils/request";
import { getLic } from './api'
import { message } from "ant-design-vue";
import offline from "@/assets/offline.png";
import Termsindex from "@/views/login/terms.vue";
import UserForm from "@/components/login/user.vue";
import PhoneForm from "@/components/login/phone.vue";
import ForgetPass from "@/components/login/forgetpass.vue";
import { UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined } from "@ant-design/icons-vue";
import { ref } from 'vue';
import ReserPass from '@/components/login/reserpass.vue';
export default {
  name: "Login",
  components: { Termsindex, UserForm, PhoneForm, ForgetPass, ReserPass, UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined },
  data() {
    const binding_1 = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        return Promise.reject("请输入密码");
      } else if (!reg.test(value)) {
        return Promise.reject("请输入正确的手机号");
      } else if (value !== this.bindForm.sconed) {
        return Promise.reject("两次密码输入不一致!");
      } else {
        if (this.bindForm.mob !== "") {
          this.$refs.bindForm.validateField("sconed");
        }
        return Promise.resolve();
      }
    };
    const binding_2 = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        return Promise.reject("请再次输入手机号");
      } else if (!reg.test(value)) {
        return Promise.reject("请输入正确的手机号");
      } else if (value !== this.bindForm.mob) {
        return Promise.reject("两次手机号输入不一致!");
      } else {
        if (this.bindForm.sconed !== "") {
          this.$refs.bindForm.validateField("mob");
        }
        return Promise.resolve();
      }
    };
    return {
      infoForm: {
        app_name: '',
        login_introduction: '',
        login_background_image: JSON.parse(localStorage.getItem('imgList')) ? JSON.parse(localStorage.getItem('imgList')).bgimg : '' || '',
        site_icon: JSON.parse(localStorage.getItem('imgList')) ? JSON.parse(localStorage.getItem('imgList')).icon : '' || '',
      },
      backImg,
      username: '',
      passmob: '',
      loading: false,
      button_login: "登录",
      rules: {
        mob_1: [
          { required: true, message: "该项为必填项", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的手机号", trigger: "blur" },
          { validator: binding_1, trigger: "change" },
        ],
        second: [
          { required: true, message: "该项为必填项", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的手机号", trigger: "blur" },
          { validator: binding_2, trigger: "change" },
        ],
      },
      codeShow: true,
      times: 60,
      newtimes: 60,
      passText: "获取验证码",
      is_user: true,
      is_pass: true,
      sty: "",
      styl: "display: none",
      h5_text: "效率就是生产力",
      is_newpass: false,
      newModel: false,
      newPassForm: {
        fpwd: "",
        spwd: "",
      },
      is_loginForm: true,
      bindForm: {
        mob: "",
        typ: "3",
      },
      bindForm_2: {
        mob: "",
        verkey: "",
        wid: this.$route.hash.substring(4, this.$route.hash.length),
      },
      bindText: "获取验证码",
      bindtimes: 60,
      bindShow: true,
      is_modify: true,
      modifyForm: {
        mob: "",
        typ: "2",
      },
      modifyForm_2: {
        verkey: "",
        typ: "2",
      },
      is_modifyPass: true,
      offline,
      qrcode: false,
      ticket: true,
      clauseModal: false, // 服务条款
      terms: ref(localStorage.getItem("login") == null ? false : true),
      bodyStyles: {
        height: "700px",
        overflow: "auto",
      },
    };
  },
  beforeMount() {
    let code = this.$route.hash.substring(1, 5);
    if (code == "") {
      this.is_loginForm = true;
      let modify = this.$route.query.redirect;
      if (modify == "modify") {
        this.h5_text = "修改密码";
        this.is_modify = false;
      } else {
        this.is_modify = true;
      }
    } else if (code == "code") {
      let codes = this.$route.hash.substring(6, this.$route.hash.length);
      $post({
        url: "auth/getToken",
        params: {
          code: codes,
        },
      }).then((res) => {
        let token = `Bearer ${res.token}`;
        this.$store.dispatch("user/login", token).then(() => {
          const _redirect = this.$route.query.redirect;
          const status = this.$route.query.status;
          const title = this.$route.query.title;
          const proj_type = this.$route.query.proj_type;
          const oper_type = this.$route.query.oper_type;
          const page = this.$route.query.page;
          const perpage = this.$route.query.perpage;
          if (_redirect) {
            if (
              _redirect == "no-permission" ||
              _redirect == "/no-permission"
            ) {
              this.$router.push({ path: "/home/workspace" });
            } else if (_redirect == "404" || _redirect == "/404") {
              this.$router.push({ path: "/home/workspace" });
            } else if (_redirect == "modify" || _redirect == "/modify") {
              this.$router.push({ path: "/home/workspace" });
            } else if ((_redirect == "refresh") | (_redirect == "/refresh")) {
              this.$router.push({ path: "/home/workspace" });
            } else if (_redirect.indexOf('mbr403') > -1) {
              this.$router.push({ path: "/home/workspace" });
            } else {
              if (_redirect.indexOf('?id=') > -1) {
                let i = _redirect.indexOf('?id=')
                let id = _redirect.slice(i + 4)
                this.$router.push({
                  path: _redirect,
                  query: { id, status, title, proj_type, oper_type, page, perpage },
                });
              } else if (_redirect.indexOf('?sub_id=') > -1) {
                let i = _redirect.indexOf('?sub_id=')
                let sub_id = _redirect.slice(i + 8)
                this.$router.push({
                  path: _redirect,
                  query: { sub_id, status, title, proj_type, oper_type, page, perpage },
                });
              } else {
                this.$router.push({
                  path: _redirect,
                  query: { status, title, proj_type, oper_type, page, perpage },
                });
              }
            }
          } else {
            this.$router.push({ path: "/home/workspace" });
          }
        });
      }).catch((err) => {
        console.log(err);
      });
    } else if (code == "tick") {
      this.is_loginForm = false;
      this.ticket = false;
    } else {
      let id = this.$route.hash.substring(4, this.$route.hash.length - 1);
      if (id == "") {
        this.is_loginForm = true;
      } else {
        this.is_loginForm = false;
      }
    }
  },
  mounted() {
    this.getInfo()
    localStorage.setItem("query", JSON.stringify({}));
    // listenKeyDownFunc({
    //   keyCode: 13,
    //   callback: () => {
    //     if (!this.is_loginForm) {
    //       this.handlerBinding("bindForm");
    //     }
    //   },
    // });
  },
  methods: {
    getInfo() {
      $get({
        url: 'auth/getConfigData',
      }).then(res => {
        let result = res.data;
        if (result.base != undefined) {
          this.infoForm.app_name = result.base.app_name
          this.infoForm.login_introduction = result.base.login_introduction
          this.h5_text = result.base.login_introduction
          this.infoForm.login_background_image = result.base.login_background_image
          this.infoForm.site_icon = result.base.site_icon
          this.$store.dispatch('layout/changeAppname', this.infoForm.app_name)
          this.$store.dispatch('layout/changeSiteicon', this.infoForm.site_icon)
        }
      }).catch(err => {
        console.log(err);
      })
    },
    handlerForgetPass() {
      this.is_pass = false;
      this.h5_text = '忘记密码';
    },
    // 绑定手机号获取验证码
    handlerBindForm(form, s) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          $post({
            url: "auth/getVerCode/",
            params: s,
          }).then((res) => {
            message.success("发送成功");
            this.bindShow = false;
            setInterval(() => {
              if (this.bindtimes > 0 && this.bindtimes <= 60) {
                this.bindtimes--;
              } else {
                this.bindShow = true;
                this.bindText = "重新发送";
                this.bindtimes = 60;
              }
            }, 1000);
          }).catch((err) => {
            message.error(err);
          });
        }
      });
    },
    // 忘记密码--下一步
    handlerForget(form) {
      $post({
        url: "auth/login",
        params: form,
      }).then((res) => {
        let modify = this.$route.query.redirect;
        if (modify == "modify") {
          this.is_modifyPass = false;
        } else {
          this.is_newpass = true;
        }
        this.passmob = res.data.mob;
        this.newPassForm.mob = res.data.mob;
        this.newModel = true;
      }).catch((err) => {
        message.error(err);
      });
    },
    // 重置
    handlerReset(form, s) {
      this.username = form;
      this.newModel = false;
      this.is_pass = true;
      this.h5_text = "效率就是生产力";
      let modify = this.$route.query.redirect;
      if (modify == "modify") {
        this.is_modify = true;
        message.success("修改密码成功，即将跳转登录页面");
      } else {
        this.is_newpass = false
        message.success("重置密码成功");
      }
    },
    // 其他登录方式
    handlerwechat() {
      // getLic().then((res) => {
      // if (res.code) {
      let appid = process.env.VUE_APP_WXBIZ_CORPID;
      let agentid = process.env.VUE_APP_WXBIZ_INDEV_AGENTID;
      let redirect_uri = process.env.VUE_APP_WXBIZ_LOGIN_RTNURI;
      this.sty = "display: none";
      this.styl = "display: block";
      this.is_pass = true;
      this.loading = false;
      this.button_login = "登录";
      var wwLogin = new WwLogin({
        id: "wx_reg",
        appid: appid,
        agentid: agentid,
        redirect_uri: encodeURIComponent(redirect_uri),
        state: this.randomString(),
        href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4O2hlaWdodDoxODBweH0KLmltcG93ZXJCb3ggLnRpdGxlIHt9Ci5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMjAwcHg7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmUgICFpbXBvcnRhbnR9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA==",
        lang: "zh",
      });
      let iframe = document.getElementsByTagName("iframe")[0];
      this.qrcode = true;
      iframe.height = "380px";
      iframe.width = "240px";
      iframe.sandbox =
        "allow-forms allow-same-origin allow-scripts allow-top-navigation";
      // } else {
      //   message.error(res.msg)
      // }
      // }).catch((err) => {
      //   message.error(err)
      // })
    },
    handlerBack() {
      this.loading = false;
      this.h5_text = "效率就是生产力";
      this.styl = "display: none";
      this.sty = "display: block";
    },
    // 绑定登录
    handlerBinding(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          $post({
            url: "auth/bindmob",
            params: {
              mob: this.bindForm.mob,
              verkey: this.bindForm_2.verkey,
              wid: this.$route.hash.substring(4, this.$route.hash.length),
            },
          }).then((res) => {
            let ticket = res.data.state;
            if (ticket == "t") {
              let token = `Bearer ${res.token}`;
              this.$store.dispatch("user/login", token).then(() => {
                const _redirect = this.$route.query.redirect;
                const status = this.$route.query.status;
                const title = this.$route.query.title;
                const proj_type = this.$route.query.proj_type;
                const oper_type = this.$route.query.oper_type;
                const page = this.$route.query.page;
                const perpage = this.$route.query.perpage;
                if (_redirect) {
                  if (_redirect == "no-permission" || _redirect == "/no-permission") {
                    this.$router.push({ path: "/home/workspace" });
                  } else if (_redirect == "404" || _redirect == "/404") {
                    this.$router.push({ path: "/home/workspace" });
                  } else if (_redirect == "modify" || _redirect == "/modify") {
                    this.$router.push({ path: "/home/workspace" });
                  } else if (_redirect == "refresh" || _redirect == "/refresh") {
                    this.$router.push({ path: "/home/workspace" });
                  } else if (_redirect.indexOf('mbr403') > -1) {
                    this.$router.push({ path: "/home/workspace" });
                  } else {
                    if (_redirect.indexOf('?id=') > -1) {
                      let i = _redirect.indexOf('?id=')
                      let id = _redirect.slice(i + 4)
                      this.$router.push({
                        path: _redirect,
                        query: { id, status, title, proj_type, oper_type, page, perpage },
                      });
                    } else if (_redirect.indexOf('?sub_id=') > -1) {
                      let i = _redirect.indexOf('?sub_id=')
                      let sub_id = _redirect.slice(i + 8)
                      this.$router.push({
                        path: _redirect,
                        query: { sub_id, status, title, proj_type, oper_type, page, perpage },
                      });
                    } else {
                      this.$router.push({
                        path: _redirect,
                        query: { status, title, proj_type, oper_type, page, perpage },
                      });
                    }
                  }
                } else {
                  this.$router.push({ path: "/home/workspace" });
                }
              });
              message.success("绑定成功", 2);
            } else {
              this.ticket = false;
            }
          }).catch((err) => {
            message.error(err);
          });
        }
      });
    },
    handlerChange(v) {
      if (v == 1) {
        this.is_user = true;
      } else {
        this.is_user = false;
      }
    },
    // 跳过此步骤
    handlerTicket(typ) {
      $post({
        url: "auth/directLogin",
        params: {
          typ: typ,
        },
      }).then((res) => {
        this.loading = false;
        this.button_login = "登录";
        let token = `Bearer ${res.token}`;
        this.$store.dispatch("user/login", token).then(() => {
          const _redirect = this.$route.query.redirect;
          const status = this.$route.query.status;
          const title = this.$route.query.title;
          const proj_type = this.$route.query.proj_type;
          const oper_type = this.$route.query.oper_type;
          const page = this.$route.query.page;
          const perpage = this.$route.query.perpage;
          if (_redirect) {
            if (
              _redirect == "no-permission" ||
              _redirect == "/no-permission"
            ) {
              this.$router.push({ path: "/home/workspace" });
            } else if (_redirect == "404" || _redirect == "/404") {
              this.$router.push({ path: "/home/workspace" });
            } else if (_redirect == "modify" || _redirect == "/modify") {
              this.$router.push({ path: "/home/workspace" });
            } else if (_redirect == "refresh" || _redirect == "/refresh") {
              this.$router.push({ path: "/home/workspace" });
            } else if (_redirect.indexOf('mbr403') > -1) {
              this.$router.push({ path: "/home/workspace" });
            } else {
              this.$router.push({
                path: _redirect,
                query: { status, title, proj_type, oper_type, page, perpage },
              });
            }
          } else {
            this.$router.push({ path: "/home/workspace" });
          }
        });
        message.success("登录成功", 4);
      }).catch((err) => {
        console.log(err);
        message.error(err);
      });
    },
    handlerClause() {
      this.clauseModal = true;
    },
    changeClause(v, s) {
      if (v.target.checked) {
        localStorage.setItem("login", "true");
      } else {
        localStorage.removeItem("login");
      }
    },
    clauseOk() {
      this.terms = true;
      localStorage.setItem("login", "true");
      this.clauseModal = false;
    },
    //随机生成字符串
    randomString() {
      let list = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = list.length;
      let pwd = "";
      for (let i = 0; i < 16; i++) {
        pwd += list.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
};
</script>

<style lang="less">
.login {
  width: 100vw;
  height: 100vh;
  min-height: 520px;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: url(../../assets/login.jpg) center/cover;

  .appdiv {
    width: 464px;
    height: 496px;
    border-radius: 10px;
    margin: auto;
    background: #fff;

    h1 {
      font-size: 28px;
      text-align: center;
      color: rgba(0, 0, 0, 0.65);
      margin: 24px auto 10px;
    }

    h5 {
      font-size: 10px;
      text-align: center;
      margin: 0 auto 40px;
      opacity: 0.43;
    }

    .login-in {
      width: 368px;
      height: 40px;
      margin: 0 auto;
      // .remenber {
      //   width: 368px;
      //   height: 55px;
      //   padding: 24px 0;
      //   font-size: 14px;
      // }
    }

    .login-on {
      width: 369px;
      height: 24px;
      margin: 55px auto;

      .login-on-1 {
        float: right;
        font-size: 14px;
        line-height: 24px;

        img {
          display: block;
          width: 24px;
          height: 24px;
          float: right;
          cursor: pointer;
        }

        img.active {
          content: url("../../assets/wechat-on.png");
        }
      }

      .login-on-2 {
        float: left;
        font-size: 14px;
        line-height: 24px;
      }

      .login-on-3 {
        float: left;
        font-size: 14px;
        line-height: 24px;

        img {
          display: block;
          width: 24px;
          height: 24px;
          float: right;
          cursor: pointer;
        }

        img.active {
          content: url("../../assets/wechat-on.png");
        }
      }
    }

    .is_modify {
      width: 369px;
      height: 24px;
      position: relative;
      top: -45px;
      left: 48px;
    }

    .code {
      width: 25%;
      height: 40px;
      float: right;
      text-align: center;
      padding: 0;
    }

    .userna {
      height: 247px;
      padding: 0 48px;

      .remenber {
        width: 368px;
        height: 55px;
        padding: 24px 0;
        font-size: 14px;
      }
    }

    .weixin {
      text-align: center;
      padding: 0 112px;

      .qr-code {
        width: 240px;
        height: 240px;
        margin-bottom: 64px;
      }

      .log {
        width: 100%;
        color: #1980ff;
        margin-bottom: 55px;
        position: absolute;
        // bottom: 35px;
        left: 0;
      }
    }

    .forget_pass {
      height: 247px;
      padding: 0 48px;
      box-sizing: border-box;
    }
  }

  .ant-tabs-nav-scroll {
    text-align: center;
  }

  .ant-tabs-bar {
    border-bottom: 0;
    margin: 0 0 16px;
  }
}

.clause_span {
  text-indent: 2em;
}

.ant-tabs-top>.ant-tabs-nav::before,
.ant-tabs-bottom>.ant-tabs-nav::before,
.ant-tabs-top>div>.ant-tabs-nav::before,
.ant-tabs-bottom>div>.ant-tabs-nav::before {
  border-bottom: 0;
}
</style>